import { render, staticRenderFns } from "./InlineEditingSavePrompt.vue?vue&type=template&id=f978dc7a&scoped=true&"
import script from "./InlineEditingSavePrompt.vue?vue&type=script&lang=js&"
export * from "./InlineEditingSavePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f978dc7a",
  null
  
)

export default component.exports